export default __webpack_public_path__ + "static/media/Ficha-Tecnica-Impresoras.4b889975.pdf";